import React from 'react'
import Navbar from '../../layout/nav/Navbar'
import Category from '../../components/category/Category'

const Categories = () => {
  return (
    <div>
        <Category/>
    </div>
  )
}

export default Categories